import { VariableType } from '@mm/state/model/AudiencesModel';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import PrimarySelect, { DropdownOption } from '../PrimarySelect/PrimarySelect';
import { AudienceFilterItemInputChildProps } from './AudienceFilterItemInput';

export const AudienceFilterItemInputVariable = (
  props: AudienceFilterItemInputChildProps,
) => {
  const {
    filter,
    setFilter,
    variables,
    busy,
    className,
    showBlankVariableOption,
    css,
  } = props;
  const items = useMemo(() => {
    const result = variables.map((v, i) => ({ ...v, id: i }));
    if (showBlankVariableOption) {
      return [
        {
          id: 0,
          name: ' ',
          friendlyName: '',
          variableId: 0,
          variableType: 'SystemVariable' as VariableType,
        },
        ...result.map(v => ({ ...v, id: v.id + 1 })),
      ];
    }
    return result;
  }, [variables]);
  const selectedItem = items.find(
    ov =>
      ov.variableId === filter.variableId &&
      ov.variableType === filter.variableType,
  );

  const customOptionRenderer = (option: DropdownOption) => (
    <span className="audience-filter-item-input__custom-option">
      {option?.friendlyName}
    </span>
  );

  const onChangeVariable = (variable: typeof items[any]) => {
    setFilter({
      ...filter,
      variableId: variable.variableId,
      variableType: variable.variableType,
      variable: variable.name,
      value: '',
      operator: undefined,
      esType: variable.esType,
    });
  };

  return (
    <div
      className={classNames(
        'audience-filter-item-input__section',
        css?.section,
        {
          [`${className}__section`]: className,
        },
      )}
    >
      <div
        className={classNames(
          'audience-filter-item-input__field-title',
          css?.fieldTitle,
          {
            [`${className}__field-title`]: className,
          },
        )}
      >
        Attribute
      </div>
      <PrimarySelect
        className={classNames(
          'audience-filter-item-input__primary-select',
          css?.select,
          {
            [`${className}__selector`]: className,
          },
        )}
        activeItemClassName={classNames(css?.selectActiveItem, {
          [`${className}__variable-selector__active-item`]: className,
        })}
        options={items}
        customOptionRenderer={customOptionRenderer}
        disabled={busy}
        value={selectedItem}
        onChange={onChangeVariable}
        showSearchFilter={true}
        customDropdownStyles={{ zIndex: '1000010' }}
        renderWithoutPopover
      />
    </div>
  );
};
